// Typed accessor for VITE_* env vars. Throws early if a required key is missing.

interface AdminUiEnv {
  VITE_SUPABASE_URL: string;
  VITE_SUPABASE_ANON_KEY: string;
  VITE_GOOGLE_CLIENT_ID: string;
  VITE_ADMIN_ACTION_WEBHOOK_URL: string;
  VITE_SEND_REPLY_WEBHOOK_URL: string;
  VITE_JOURNEY_EXPORT_WEBHOOK_URL: string;
  /** Workflow 15 — compose a brand-new ticket and send the first email. */
  VITE_CREATE_TICKET_WEBHOOK_URL: string;
  /** Workflow 16 — Slack DM fan-out to admins on new leave requests. */
  VITE_LEAVE_NOTIFY_WEBHOOK_URL: string;
  /** Workflow 17 — Customer Assist live sessions (start + end). */
  VITE_ASSIST_WEBHOOK_URL: string;
  VITE_ALLOWED_DOMAINS: string;
}

function read(key: keyof AdminUiEnv): string {
  const raw = (import.meta.env as Record<string, string | undefined>)[key];
  if (!raw || raw.length === 0) {
    // We don't throw at module load — that would crash the whole app at import time.
    // Instead surface a console warning; consumers that need a value will throw when they use it.
    console.warn(`[env] ${key} is not set. Run \`pnpm sync-env\` to copy values from the root .env.`);
    return '';
  }
  return raw;
}

export const env: AdminUiEnv = {
  VITE_SUPABASE_URL: read('VITE_SUPABASE_URL'),
  VITE_SUPABASE_ANON_KEY: read('VITE_SUPABASE_ANON_KEY'),
  VITE_GOOGLE_CLIENT_ID: read('VITE_GOOGLE_CLIENT_ID'),
  VITE_ADMIN_ACTION_WEBHOOK_URL: read('VITE_ADMIN_ACTION_WEBHOOK_URL'),
  VITE_SEND_REPLY_WEBHOOK_URL: read('VITE_SEND_REPLY_WEBHOOK_URL'),
  VITE_JOURNEY_EXPORT_WEBHOOK_URL: read('VITE_JOURNEY_EXPORT_WEBHOOK_URL'),
  VITE_CREATE_TICKET_WEBHOOK_URL: read('VITE_CREATE_TICKET_WEBHOOK_URL'),
  VITE_LEAVE_NOTIFY_WEBHOOK_URL: read('VITE_LEAVE_NOTIFY_WEBHOOK_URL'),
  VITE_ASSIST_WEBHOOK_URL: read('VITE_ASSIST_WEBHOOK_URL'),
  VITE_ALLOWED_DOMAINS: read('VITE_ALLOWED_DOMAINS'),
};

export function allowedDomains(): string[] {
  return env.VITE_ALLOWED_DOMAINS.split(',')
    .map((d) => d.trim().toLowerCase())
    .filter((d) => d.length > 0);
}
